import { useMutation } from "@tanstack/react-query";
import httpRequest from "app/lib/axios/index";

interface SendOtpRequest {
  phoneNumber: string;
}

interface SendOtpResponse {
  message: string;
  success: boolean;
  applicantId: string;
}

const sendOtp = async ({
  phoneNumber,
}: SendOtpRequest): Promise<SendOtpResponse> => {
  const response = await httpRequest.post<SendOtpResponse>(
    "/applicant/send-otp",
    { phoneNumber }
  );
  return response.data;
};

export const useSendOtp = () => {
  return useMutation<SendOtpResponse, Error, SendOtpRequest>({
    mutationFn: sendOtp,
  });
};
